type IEquipmentIconProps = { size?: number };

const base = { fill: 'none' as const, stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export function EquipmentIcon({ size = 17 }: IEquipmentIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ color: 'hsl(var(--primary))' }} {...base}>
      <rect x="4" y="4" width="16" height="16" rx="2"/>
      <rect x="9" y="9" width="6" height="6" rx="1"/>
      <path d="M15 2v2" strokeWidth="2"/>
      <path d="M15 20v2" strokeWidth="2"/>
      <path d="M2 15h2" strokeWidth="2"/>
      <path d="M2 9h2" strokeWidth="2"/>
      <path d="M20 15h2" strokeWidth="2"/>
      <path d="M20 9h2" strokeWidth="2"/>
      <path d="M9 2v2" strokeWidth="2"/>
      <path d="M9 20v2" strokeWidth="2"/>
    </svg>
  );
}
